"use client";

import React from "react";
import { FileText, ScanFace, Cloud } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Tesla FSD & Vision",
  description: "Tesla Full Self-Driving utnyttjar avancerade neurala nätverk och vision-teknik för att navigera komplexa stadsmiljöer. Systemet lär sig kontinuerligt från miljontals fordon för att maximera trafiksäkerheten och effektiviteten i realtid.",
  buttonText: "Utforska FSD",
  buttonLink: "/InsightsPage",
  icon: FileText
}, {
  title: "Waymo Sensor Suite",
  description: "Waymo Driver använder en sofistikerad uppsättning av Lidar, radar och kameror för en total 360-graders överblick. Detta möjliggör autonom körning i krävande väderförhållanden och tät stadstrafik dygnet runt med militärklassad precision.",
  buttonText: "Läs om sensorer",
  buttonLink: "/InsightsPage",
  icon: ScanFace
}, {
  title: "XPeng NGP Integration",
  description: "XPengs NGP-system integrerar hårdvara och mjukvara för en sömlös körupplevelse på motorvägar och stadsgator. Med realtidsoptimering hanterar systemet filbyten och komplexa korsningar med hög precision och mänsklig finess.",
  buttonText: "Se NGP-teknik",
  buttonLink: "/InsightsPage",
  icon: Cloud
}];
function FeatureRow({
  feature,
  index
}: {
  feature: (typeof features)[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <div data-section-id="147528" ref={ref} data-index={index} className={`flex flex-col lg:flex-row border-b border-muted last:border-b-0 transition-all duration-1000 ease-out hover:shadow-md hover:bg-accent/10 transition-shadow duration-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      <div className="flex-1 p-8 md:p-16 lg:p-24 flex flex-col justify-center items-start lg:border-r border-muted">
        <h3 className="text-2xl md:text-3xl font-serif font-bold text-primary mb-6 leading-tight">
          {feature.title}
        </h3>
        <p className="text-base text-muted-foreground mb-10 max-w-2xl leading-[1.6] font-sans font-normal">
          {feature.description}
        </p>
        <Button asChild variant="ghost" className="border border-primary text-primary hover:bg-primary hover:text-primary-foreground rounded-[3px] px-8 py-6 text-base md:text-lg font-bold transition-colors">
          <Link to={feature.buttonLink}>{feature.buttonText}</Link>
        </Button>
      </div>
      <div className="flex-1 p-12 md:p-16 lg:p-24 flex items-center justify-center">
        <feature.icon className="w-40 h-40 md:w-56 md:h-56 text-primary" strokeWidth={1} />
      </div>
    </div>;
}
export default function Funktioner() {
  return <section id="funktioner" className="bg-secondary py-12 md:py-24 px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-[1400px] mx-auto bg-card rounded-[3px] border border-muted overflow-hidden shadow-sm">
        <div className="flex flex-col">
          {features.map((feature, i) => <FeatureRow key={i} feature={feature} index={i} />)}
        </div>
      </div>
    </section>;
}